import type { ExperienceDetails } from '@atlassian/jira-business-experience-tracking/src/types.tsx';

export const CREATE_ISSUE_EXPERIENCE: ExperienceDetails = {
	experience: 'createIssue',
	packageName: 'jiraBusinessIssueCreate',
	teamName: 'wanjel',
};
